import { Form } from "antd"

import Flex from "#blocks/Flex"
import { AddUserFormValues } from "#customTypes/composedTypes/userTypes"

import TeacherAttendanceList from "./TeacherAttendanceList"
import UserEvaluationsList from "./UserEvaluationsList"

const TeacherInfo = () => {
  const form = Form.useFormInstance<AddUserFormValues>()
  const userId = form.getFieldValue("id")

  const MAX_HEIGHT = 900

  return (
    <Flex gap={30} style={{ height: MAX_HEIGHT }}>
      <Flex style={{ flex: 1, height: "100%" }}>
        <TeacherAttendanceList userId={userId} />
      </Flex>
      <Flex col style={{ flex: 1, height: "100%" }}>
        <UserEvaluationsList userId={userId} />
      </Flex>
    </Flex>
  )
}

export default TeacherInfo
